import styled from 'styled-components'

export const AdditionalSearchSelects = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;

  @media ${ (props) => props.theme.breakpoints.devices.max.td } {
    flex-direction: column;
  }

  //background: #F5FF52;

  .select-wrapper {
    &.one {
      width: 100%;
    }
    &.two {
      width: 45%;
    }
    &.three {
      width: 30%;
    }

    &.two,
    &.three {
      @media ${ (props) => props.theme.breakpoints.devices.max.td } {
        width: 100%;
        padding-bottom: 15px;
      }
    }

    .select-headline {
      display: flex;
      flex-direction: row;
      //background: #abdde5;

      .select-label {
        height: 25px;
        font-size: inherit;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        hyphens: auto;
        font-weight: 400;
        line-height: 1.44;
      }

      > span {
        margin-top: 5px;
        margin-left: 10px;
      }
    }

    // overwrite select styles
    .additional-searchbar-selects {
      width: 100%;
      min-width: auto;
      border: solid 1px ${ (props) => props.theme.colors['icon-grau3'] };

      > span {
        width: inherit;
        > span {
          background-color: ${ (props) =>
            props.theme.colors['hintergrund-prio2'] };
          div {
            overflow-x: hidden;
            span {
              width: 100%;
              overflow-x: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
      * li {
        max-width: 100%;
        white-space: pre-wrap;
      }
    }
  }
`
